import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Login from '../views/Loginnew.vue'
import Studentinfo from '../views/studentinfo.vue'
import House from '../views/house.vue'
import Updatepassword from '../views/updatepassword.vue'
import StudentReview from '../views/studentReview.vue'
import WebRead from '../views/webread.vue'
import MLogin from '../views/mobile/login.vue'
import Mprompt from '../views/mobile/prompt.vue'
import Mstudentinfo from '../views/mobile/studentinfo.vue'
import Vr from '../views/vr.vue'
import Mvr from '../views/mvr.vue'
import MRead from '../views/mobile/mread.vue'
import Mhouse from '../views/mobile/house.vue'
import Mhousereview from '../views/mobile/housereview.vue'
import MUpdatepwd from '../views/mobile/updatepwd.vue'
import Print from '../views/print.vue'
import Scan from '../views/manager/scan.vue'
import Studentroom from '../views/manager/studentroom.vue'
import Managelogin from '../views/manager/managelogin.vue'
import charts from '../views/charts.vue'
import chartsSource from '../views/chartsSource.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/print',
    name: 'Print',
    component: Print,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/studentinfo',
    name: 'Studentinfo',
    component: Studentinfo    
  }, {
    path: '/vr',
    name: 'vr',
    component: Vr    
  },
  {
    path: '/house',
    name: 'house',
    component: House,
    meta:{isShow:true,keepAlive: false, //此组件不需要被缓存
    }        
  },
  {
    path: '/update',
    name: 'update',
    component: Updatepassword
  },
  {
    path: '/view',
    name: 'view',
    component: StudentReview,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/read',
    name: 'read',
    component: WebRead,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/m',
    name: 'mlogin',
    component: MLogin,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/m/prompt',
    name: 'mprompt',
    component: Mprompt
  },
  {
    path: '/m/studentinfo',
    name: 'mstudentinfo',
    component: Mstudentinfo,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/m/vr',
    name: 'mvr',
    component: Mvr
  },
  {
    path: '/m/read',
    name: 'mread',
    component: MRead,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }
  },
  {
    path: '/m/house',
    name: 'mhouse',
    component: Mhouse   ,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }   
  },
  {
    path: '/m/houseview',
    name: 'mhousereview',
    component: Mhousereview,
    meta: {
     keepAlive: false, //此组件不需要被缓存
    }      
  },
  {
    path: '/m/updatepwd',
    name: 'mupdatepwd',
    component: MUpdatepwd      
  },{
    path: '/m/scan',
    name: 'mscan',
    component: Scan      
  },{
    path: '/studentroom',
    name: 'mstudentroom',
    component: Studentroom     
    
  },{
    path: '/m/managelogin',
    name: 'managelogin',
    component: Managelogin     
    
  },{
    path: '/charts',
    name: 'charts',
    component: charts     
    
  },{
    path: '/chartsSource',
    name: 'chartsSource',
    component: chartsSource     
    
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
